<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-flip-horizontal`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 4h2c.51 0 .935.388.993.884L26 5v38c0 .51-.388.935-.884.993L25 44h-2c-.51 0-.935-.388-.993-.884L22 43V5c0-.51.388-.935.884-.993L23 4zm-6 3a1 1 0 011 1v33a1 1 0 01-1 1H7a2 2 0 01-2-2V9a2 2 0 012-2h10zm24 1a2 2 0 012 2v29a2 2 0 01-2 2H31a1 1 0 01-1-1v-2a1 1 0 01.999-1H39V12h-8a1 1 0 01-1-1V9a1 1 0 011-1h10z"/></svg>
</template>
<script>

export default {
  name: 'IconFlipHorizontal',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
